// ModalLabel.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './ModalLabel.css';

/**
 * ModalLabel
 * 
 * A simple label component for modals.
 *  
 * @param {string} label - The text to display inside the label.
 * 
 * @returns {ReactNode} - ModalLabel.
 */
const ModalLabel = React.memo(({ label }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (

        <div
            className="modal-label-container"
            style={{
                color: theme.foregroundMuted,
            }}
        >
            {label}
        </div>
    );

});

// Dev Tools
ModalLabel.displayName = 'ModalLabel';

export default ModalLabel;

